/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ShutdownStatus,
  ShutdownStatus$inboundSchema,
} from "./shutdownstatus.js";

/**
 * Websocket event type
 */
export const ShutdownBannerEventType = {
  AlarmActivation: "alarm_activation",
  Error: "error",
  Keepalive: "keepalive",
  Reading: "reading",
  Setting: "setting",
  ShutdownBanner: "shutdown_banner",
  Trends: "trends",
  UserActivity: "user_activity",
} as const;
/**
 * Websocket event type
 */
export type ShutdownBannerEventType = OpenEnum<typeof ShutdownBannerEventType>;

/**
 * Record of a shutdown banner change. Returns the current state of the shutdown and the desired banner content.
 *
 * @remarks
 * 	Zero or one fields are present: zero for keepalives; for other event types.
 * 	An empty (keepalive) event is sent periodically to prevent load balancers and firewalls from closing the connection due to idleness.
 */
export type ShutdownBannerEvent = {
  /**
   * The trace metadata, initialized by the trace stream interceptor
   */
  traceMetadata?: { [k: string]: string } | undefined;
  /**
   * Information about the shutdown
   */
  shutdownStatus?: ShutdownStatus | undefined;
  /**
   * Websocket event type
   */
  type: ShutdownBannerEventType;
};

/** @internal */
export const ShutdownBannerEventType$inboundSchema: z.ZodType<
  ShutdownBannerEventType,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(ShutdownBannerEventType);

/** @internal */
export const ShutdownBannerEvent$inboundSchema: z.ZodType<
  ShutdownBannerEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  TraceMetadata: types.optional(z.record(types.string())),
  shutdown_status: types.optional(ShutdownStatus$inboundSchema),
  type: ShutdownBannerEventType$inboundSchema.default("shutdown_banner"),
}).transform((v) => {
  return remap$(v, {
    "TraceMetadata": "traceMetadata",
    "shutdown_status": "shutdownStatus",
  });
});

export function shutdownBannerEventFromJSON(
  jsonString: string,
): SafeParseResult<ShutdownBannerEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ShutdownBannerEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ShutdownBannerEvent' from JSON`,
  );
}
